import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  SimpleForm,
  Edit,
  TextInput,
  Create,
  TabbedForm,
  FormTab
} from "react-admin";

//import AvatarField from "./AvatarField";

export const ContactList = props => (
  <List title="Contacts" {...props} exporter={false} bulkActionButtons={false}>
    <Datagrid rowClick="edit">
      <TextField label="Name" source="name" />
      <TextField label="Email" source="email" />
      <TextField label="Message" source="message" />
      <DateField
        label="Last Update"
        source="lastupdate"
        locales="lt"
        showTime
      />
    </Datagrid>
  </List>
);

const ContactName = ({ record }) => {
  return <span>Contact {record ? `"${record.name}"` : ""}</span>;
};

export const ContactEdit = props => (
  <Edit title={<ContactName />} {...props}>
    <TabbedForm>
      <FormTab label="Contact information">
        <TextInput source="name" />
        <TextInput label="email" source="email" />
        <TextInput label="message" source="message" />
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
    </TabbedForm>
  </Edit>
);

export const ContactCreate = props => (
  <Create title="Create Contact" {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput label="Email" source="email" />
      <TextInput label="Message" source="message" />
    </SimpleForm>
  </Create>
);


// WEBPACK FOOTER //
// ./src/contacts.js